/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, {
  createContext, useContext, useEffect, useState,
} from 'react';

import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { AuthApiContextProps, AuthApiProviderProps } from './AuthApiContext.types';

const AuthApiContext = createContext<AuthApiContextProps>(undefined!);
export function useAuthApi() {
  return useContext(AuthApiContext);
}

/**
 * AuthApi Provider
 * @param param0
 * @returns
 */
export function AuthApiProvider({
  children,
  cache,
}: AuthApiProviderProps) {
  const [authApiClient, setAuthApiClient] = useState<ApolloClient<NormalizedCacheObject>>();

  useEffect(() => {
    const httpLink = createHttpLink({
      uri: `${process.env.REACT_APP_AUTH_API_URL}`,
    });

    const appIdHeader = process.env.REACT_APP_ID ? { appid: process.env.REACT_APP_ID } : {};
    const authLink = setContext((_, { headers }) => ({
      headers: {
        ...appIdHeader,
        ...headers,
      },
    }));

    const client = new ApolloClient({
      cache: cache ?? new InMemoryCache(),
      link: authLink.concat(httpLink),
      connectToDevTools: true,
    });

    client.resetStore();
    setAuthApiClient(client);
  }, []);

  return (
    <AuthApiContext.Provider
      value={{
        authApiClient,
      }}
    >
      {children}
    </AuthApiContext.Provider>
  );
}
